"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedDocumentTrackingHttpService = void 0;
const shared_document_administration_1 = require("../../types/shared-documents/shared-document-administration");
const shared_document_tracking_1 = require("../../types/shared-documents/shared-document-tracking");
const http_service_1 = require("../http.service");
/**
 * The administration's follow-up of one shared document (#849): its detail
 * and counters, recipients, send log and e-mail, the reminder and the
 * deletion.
 */
class SharedDocumentTrackingHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/documents`);
    }
    /**
     * Loads a document with its targets, publisher and counters.
     *
     * @param id - The document.
     * @returns The document as the administration follows it.
     */
    getTracking(id) {
        return this.get(`${encodeURIComponent(id)}/tracking`, { schema: shared_document_tracking_1.getSharedDocumentTrackingApiResponseSchema });
    }
    /**
     * Lists one page of the document's current recipients.
     *
     * @param params.id - The document.
     * @param params.payload - Page, page size and optional status.
     * @returns The page.
     */
    getRecipients(params) {
        const { id, payload } = params;
        return this.get(`${encodeURIComponent(id)}/recipients`, {
            params: {
                page: String(payload.page),
                per_page: String(payload.per_page),
                ...(payload.status ? { status: payload.status } : {}),
            },
            schema: shared_document_tracking_1.listSharedDocumentRecipientsApiResponseSchema,
        });
    }
    /**
     * Lists one page of the document's send log, newest first.
     *
     * @param params.id - The document.
     * @param params.payload - Page and page size.
     * @returns The page.
     */
    getNotifications(params) {
        const { id, payload } = params;
        return this.get(`${encodeURIComponent(id)}/notifications`, {
            params: {
                page: String(payload.page),
                per_page: String(payload.per_page),
            },
            schema: shared_document_tracking_1.listSharedDocumentNotificationsApiResponseSchema,
        });
    }
    /**
     * Renders the e-mail the document's recipients get.
     *
     * @param params.id - The document.
     * @param params.payload - The first name greeted.
     * @returns The subject and the HTML.
     */
    getEmailPreview(params) {
        return this.get(`${encodeURIComponent(params.id)}/email-preview`, {
            params: { recipientFirstName: params.payload.recipientFirstName },
            schema: shared_document_administration_1.previewSharedDocumentNotificationApiResponseSchema,
        });
    }
    /**
     * Reminds the current recipients who still owe a reading.
     *
     * @param id - The document.
     * @returns How many reminder e-mails were queued.
     */
    remind(id) {
        return this.post(`${encodeURIComponent(id)}/reminders`, { schema: shared_document_tracking_1.remindSharedDocumentRecipientsApiResponseSchema });
    }
    /**
     * Deletes the document for good.
     *
     * @param id - The document.
     * @returns Nothing; the API answers 204 with an empty body, read as a blob
     *   because an empty body is not JSON.
     */
    remove(id) {
        return this.fetch(this.getApiUrlOf(encodeURIComponent(id)), {
            method: 'DELETE',
            transformTo: 'blob',
        }).then(() => undefined);
    }
}
exports.SharedDocumentTrackingHttpService = SharedDocumentTrackingHttpService;
